import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static values = {
    options: Object,
    circleRadius: Number,
    polygon: Array,
    radii: Array
  }

  async connect() {
    const { Map } = await google.maps.importLibrary('maps');

    const map = new Map(this.element, {
      ...this.optionsValue,
      zoom: this.polygonValue ? 16 : 14,
      disableDefaultUI: true
    });

    if (this.polygonValue && this.polygonValue.length > 0) {
      // Construct the polygon.
      new google.maps.Polygon({
        paths: this.polygonValue,
        map,
        strokeColor: '#5A75D4',
        strokeOpacity: 0.8,
        strokeWeight: 3,
        fillColor: '#5A75D4',
        fillOpacity: 0.35,
      });
    }

    if (this.circleRadiusValue) {
      new google.maps.Circle({
        strokeColor: '#0044ff',
        strokeOpacity: 0.26,
        strokeWeight: 2,
        fillColor: '#0044ff',
        fillOpacity: 0.17,
        map,
        center: this.optionsValue.center,
        radius: this.circleRadiusValue,
      });
    } else if (this.radiiValue && this.radiiValue.length > 0) {
      const circles = this.radiiValue.map(radius => (
        new google.maps.Circle({
          strokeColor: '#0044ff',
          strokeOpacity: 0.26,
          strokeWeight: 2,
          fillColor: '#0044ff',
          fillOpacity: 0.17,
          map,
          center: this.optionsValue.center,
          radius: radius,
        })
      ));

      map.fitBounds(circles[circles.length - 1].getBounds());
    } else {
      new google.maps.Marker({
        position: this.optionsValue.center,
        map
      });
    }
  }
}

